import React from 'react';

export interface ListItemProps {
  icon: React.ReactNode;
  text: string;
  selected: boolean;
  onClick: () => void;
  className?: string;
}

export const ListItem: React.FC<ListItemProps> = ({ icon, text, selected, onClick, className }) => {
  return (
    <div
      className={`w-full h-6 flex items-center justify-center gap-2 cursor-pointer rounded hover:bg-neutral-200 ${selected ? 'bg-taskonio-green-100 border border-taskonio-green-200' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="w-4 h-4 flex items-center ml-1 text-neutral-900">{icon}</div>
      <div className="flex-1">{text}</div>
    </div>
  );
};

export default ListItem;
